module.exports = __webpack_public_path__ + "img/disaster.67850c4.svg";